import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getDataFromLocalStorage } from "utils/helpers";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import "./Layout.scss";

const Layout = ({ children, handleLogout }) => {
  const navigate = useNavigate();
  useEffect(() => {
    if (!getDataFromLocalStorage("access_token")) {
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div id="layout-container">
      <Sidebar handleLogout={handleLogout} />
      <div className="flex-grow-1">
        <Navbar handleLogout={handleLogout} />
        <div className="body-container-block">{children}</div>
      </div>
    </div>
  );
};

export default Layout;
